import { SideModal } from '@design-system/components/modal/sideModal';
import {
  contentWrapper,
  infoWrapper,
  inputsWrapper,
  thumbnailWrapper,
  videoPlayer,
  videoWrapper,
} from './EditVideo.css';
import { Input } from '@design-system/components/input/input';
import { Textarea } from '@design-system/components/textarea/textarea';
import { Typography } from '@design-system/components/typography/typography';
import { Button } from '@design-system/components/button/button';
import { sprinkles } from '@design-system/sprinkles.css';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import SelectThumbnail from './SelectThumbnail';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Player } from '../../../../../common/videos/Player';

import { Controller } from 'react-hook-form';

import { VideosViewModel } from '../../videos.viewModel';
import { LibraryVideo } from '../../videos.domain';

type VideoEditProps = {
  onClose: () => void;
  video: LibraryVideo;
  submittingEdit: boolean;
  showChangeThumbnail: boolean;
} & Pick<
  VideosViewModel,
  'dispatch' | 'control' | 'editErrors' | 'submittingEdit'
>;

export const EditVideo = (p: VideoEditProps) => {
  return (
    <SideModal
      isOpen={true}
      onClose={p.onClose}
      title={p?.video?.name}
      primaryCta={{
        caption: 'Save',
        onClick: () => p.dispatch({ type: 'submitEdit' }),
      }}
    >
      <div className={contentWrapper}>
        {p.showChangeThumbnail ? (
          <div className={thumbnailWrapper}>
            <Button
              variant="text"
              onClick={() => p.dispatch({ type: 'backEdit' })}
              disabled={p.submittingEdit}
              className={sprinkles({
                width: 'max-content',
              })}
            >
              <div
                className={sprinkles({
                  display: 'flex',
                  alignItems: 'center',
                  gap: 'm',
                })}
              >
                <FontAwesomeIcon icon={faArrowLeft} /> Back
              </div>
            </Button>
            <div className={sprinkles({ p: 'l' })}>
              <SelectThumbnail
                video={p.video as any} // will be removed
                onChange={(value) =>
                  p.dispatch({ type: 'thumbnailTimestamp', payload: value })
                }
                onRestore={() => p.dispatch({ type: 'restoreThumbnail' })}
                submitting={p.submittingEdit}
              />
            </div>
          </div>
        ) : (
          <div className={infoWrapper}>
            <div className={videoWrapper}>
              <Typography>File</Typography>
              <div className={videoPlayer}>
                <Player
                  src={p.video.videoSrc}
                  poster={p.video.poster}
                  duration={p.video.duration}
                  height={200}
                  width={260}
                />
              </div>
              <div
                className={sprinkles({
                  display: 'flex',
                  justifyContent: 'center',
                })}
              >
                <Button
                  variant="text"
                  onClick={() => p.dispatch({ type: 'changeThumbnail' })}
                  disabled={p.submittingEdit}
                >
                  Change thumbnail
                </Button>
              </div>
            </div>
            <div className={inputsWrapper}>
              <Controller
                name={'name'}
                control={p.control}
                render={({ field: { onChange, value } }) => (
                  <Input
                    label="Title"
                    required={true}
                    disabled={p.submittingEdit}
                    value={value}
                    onChange={onChange}
                    error={p.editErrors?.['name']?.message}
                  />
                )}
              />

              <Controller
                name={'description'}
                control={p.control}
                render={({ field: { onChange, value } }) => (
                  <Textarea
                    label="Descritpion"
                    rows={4}
                    disabled={p.submittingEdit}
                    value={value}
                    onChange={onChange}
                    error={p.editErrors?.['description']?.message}
                  />
                )}
              />
            </div>
          </div>
        )}
      </div>
    </SideModal>
  );
};
